export default "__VITE_ASSET__PvsMMyIX__"